import {TermsType} from "./terms-of-agreement.model";
/**
 * Model reprezentujący treść Klauzuli Informacyjnej (Obowiązek Informacyjny RODO/GDPR).
 * Przechowuje tekst prawny, który administrator danych musi przedstawić użytkownikowi
 * zgodnie z przepisami o ochronie danych osobowych.
 * Dokument ten jest często wersjonowany (data utworzenia), aby śledzić zmiany w polityce prywatności.
 */
export class InformationObligation {
  /** Unikalny identyfikator tej konkretnej wersji klauzuli. */
  public uuid: string;

  /**
   * Data utworzenia/publikacji dokumentu.
   * Służy do ustalenia, od kiedy dana wersja klauzuli obowiązuje.
   */
  public created: Date;
  public value: string;
  public createdByUUID: string;
  public vClientUUID: string;
  public vetcodeId: number;
  public jsonValue: string;
  public type: TermsType;
  public importSessionUUID: string;
  public url: string;
}

/**
 * Enum określający źródło pochodzenia Klauzuli Informacyjnej (sposób utworzenia).
 */
export enum InformationObligationType {
  /** Regulamin wygenerowany bezpośrednio w systemie.
   */
  GENERATED = 'GENERATED',

  /** Regulamin zaimportowany z zewnątrz.
   */
  IMPORTED = 'IMPORTED'
}

